import { AdminApiClient } from '@guiker/payment-shared'
import { useAuthenticatedApiClient } from '@guiker/react-framework'

export const useAdminPaymentApiClient = useAuthenticatedApiClient(AdminApiClient)
